import { Link } from 'react-router-dom';
import { ChevronRight, ShieldFillCheck } from 'react-bootstrap-icons';

export function StaffPageHeader({ icon, title, description, actions }) {
  return (
    <div className="sp-page-header">
      <nav className="sp-breadcrumb" aria-label="breadcrumb">
        <Link to="/staff" className="sp-breadcrumb-link">
          <ShieldFillCheck aria-hidden="true" /> Staff Panel
        </Link>
        <ChevronRight className="sp-breadcrumb-sep" aria-hidden="true" />
        <span className="sp-breadcrumb-current" aria-current="page">{title}</span>
      </nav>
      <div className="sp-page-header-row">
        <div className="sp-page-header-title">
          {icon && <span className="sp-page-header-icon" aria-hidden="true">{icon}</span>}
          <h2>{title}</h2>
        </div>
        {actions && <div className="sp-page-header-actions">{actions}</div>}
      </div>
      {description && <p className="sp-page-header-desc">{description}</p>}
    </div>
  );
}
